import {
  ERR_MSG_5XX,
  ERR_MSG_ON_REQUEST,
  ERR_MSG_SET_REQUEST,
} from 'services/utility/constants'

export default (error) => {
  if (error.response) {
    const response = {
      isErrorResponse: true,
      errorMessage: ERR_MSG_5XX,
    }
    return { ...error, response }
  }
  if (error.request) {
    return {
      ...error.request,
      isErrorResponse: true,
      errorMessage: ERR_MSG_ON_REQUEST,
    }
  }
  return {
    ...error.config,
    isErrorResponse: true,
    errorMessage: ERR_MSG_SET_REQUEST,
  }
}



// WEBPACK FOOTER //
// ./services/api/errorHandler.js